import React from "react";
import { Box } from "@material-ui/core";
import { useFormikContext } from "formik";
import { StaticLookupsIds } from "../../../../../assets/json/StaticLookupsIds";
import {
  GetAllCampaigns,
  GetAllDevelopersContactsAPI,
  getProperties,
  lookupItemsGetId,
} from "../../../../../Services";
import {
  CustomRangeSlider,
  FBFieldWrapper,
  CustomAsyncAutocomplete,
} from "../../../../../Components";
import { useTranslate } from "../../../../../Hooks";

import useStyles from "../styles";

function OptionalFieldDetails() {
  const styles = useStyles();
  const { setFieldValue, values } = useFormikContext();
  const { translate } = useTranslate("NewAgentsRotationCriteria");

  return {
    developer: () => (
      <Box
        display="flex"
        className={styles.optionalFieldContent}
        justifyContent="space-between"
      >
        <label className={styles.label}>{translate("developer-label")}</label>
        <Box flexBasis="60%">
          <CustomAsyncAutocomplete
            rootCustomClasses={styles.inputwrapper}
            autocompleteClasses={styles.optionalField}
            multiple
            selectedValues={values.developer}
            onChange={(_e, value) => setFieldValue("developer", value)}
            mapper={(data) => {
              return data.map((item) => {
                const developerContact =
                  item?.contact && JSON.parse(item.contact);
                return {
                  developerId: item.contactsId,
                  developerName: developerContact?.contact?.company_name,
                };
              });
            }}
            queryKey={"search"}
            onFetchData={GetAllDevelopersContactsAPI}
            filter={{ pageIndex: 1, pageSize: 50 }}
            displayLabel={(option) => option?.developerName ?? ""}
            renderOption={(option) => option?.developerName}
            chipsLabel={(option) => {
              return option?.developerName;
            }}
            getOptionSelected={(option, value) =>
              option?.developerId === value?.developerId
            }
            refetchOnSearch
          />
        </Box>
      </Box>
    ),
    unitType: () => (
      <Box
        display="flex"
        justifyContent="space-between"
        className={styles.optionalFieldContent}
      >
        <label className={styles.label}>{translate("unit-type-label")}</label>
        <Box flexBasis="60%">
          <CustomAsyncAutocomplete
            autocompleteClasses={styles.optionalField}
            multiple
            displayLabel={(option) => option?.unitTypeName ?? ""}
            renderOption={(option) => option?.unitTypeName}
            chipsLabel={(option) => option?.unitTypeName}
            getOptionSelected={(option, value) =>
              option?.unitTypeId === value?.unitTypeId
            }
            selectedValues={values.rotationSchemeUnitTypes}
            onChange={(_e, value) =>
              setFieldValue("rotationSchemeUnitTypes", value)
            }
            onFetchData={lookupItemsGetId}
            filter={{
              lookupTypeId: StaticLookupsIds.UintType,
              pageIndex: 1,
              pageSize: 10000,
            }}
            mapper={(data) =>
              data.map(({ lookupItemName, lookupItemId }) => ({
                unitTypeId: lookupItemId,
                unitTypeName: lookupItemName,
              }))
            }
            withoutSearchButton
            rootCustomClasses={styles.inputwrapper}
          />
        </Box>
      </Box>
    ),
    priceRange: () => (
      <Box className={styles.optionalField}>
        <FBFieldWrapper
          labelPosition="side"
          label={translate("price-range-label")}
        >
          <CustomRangeSlider
            value={values.priceRange}
            handleChange={(e, newValue) => {
              if (newValue?.[0] || newValue?.[1])
                if (newValue?.[0] > newValue?.[1]) return;
              setFieldValue("priceRange", [newValue?.[0], newValue?.[1]]);
            }}
            min={0}
            max={600000}
            valueLabelDisplay="off"
            preInputText={"AED"}
          />
        </FBFieldWrapper>
      </Box>
    ),
    size: () => (
      <Box className={styles.optionalField}>
        <FBFieldWrapper labelPosition="side" label={translate("size-label")}>
          <CustomRangeSlider
            value={values.size}
            handleChange={(_, newValue) => {
              if (newValue?.[0] || newValue?.[1])
                if (newValue?.[0] > newValue?.[1]) return;
              setFieldValue("size", [newValue?.[0], newValue?.[1]]);
            }}
            min={0}
            max={10000}
            valueLabelDisplay="off"
            preInputText={"Ft"}
          />
        </FBFieldWrapper>
      </Box>
    ),
    bedrooms: () => (
      <Box className={styles.optionalField}>
        <FBFieldWrapper labelPosition="side" label={translate("bedroom-label")}>
          <CustomRangeSlider
            value={values.bedrooms}
            handleChange={(e, newValue) => {
              if (newValue?.[0] || newValue?.[1])
                if (newValue?.[0] > newValue?.[1]) return;
              setFieldValue("bedrooms", [newValue?.[0], newValue?.[1]]);
            }}
            min={0}
            max={8}
            valueLabelDisplay="off"
          />
        </FBFieldWrapper>
      </Box>
    ),
    mediaDetails: () => (
      <Box
        display="flex"
        justifyContent="space-between"
        className={styles.optionalFieldContent}
      >
        <label className={styles.label}>
          {translate("media-detail-label")}
        </label>
        <Box flexBasis="60%">
          <CustomAsyncAutocomplete
            autocompleteClasses={styles.optionalField}
            multiple
            selectedValues={values.rotationSchemeMedias}
            displayLabel={(option) => option?.mediaDetailsName ?? ""}
            renderOption={(option) => {
              return option?.mediaDetailsName;
            }}
            chipsLabel={(option) => option?.mediaDetailsName}
            getOptionSelected={(option, value) =>
              option?.mediaDetailsId === value?.mediaDetailsId
            }
            filter={{
              lookupTypeId: StaticLookupsIds.MediaDetail,
              pageIndex: 1,
              pageSize: 10000,
            }}
            onFetchData={lookupItemsGetId}
            mapper={(data) =>
              data.map(({ lookupItemName, lookupItemId }) => ({
                mediaDetailsId: lookupItemId,
                mediaDetailsName: lookupItemName,
              }))
            }
            onChange={(_e, value) =>
              setFieldValue("rotationSchemeMedias", value)
            }
            rootCustomClasses={styles.inputwrapper}
            withoutSearchButton
          />
        </Box>
      </Box>
    ),
    leadCampaign: () => (
      <Box
        display="flex"
        justifyContent="space-between"
        className={styles.optionalFieldContent}
      >
        <label className={styles.label}>
          {translate("lead-campaign-label")}
        </label>
        <Box flexBasis="60%">
          <CustomAsyncAutocomplete
            autocompleteClasses={styles.optionalField}
            multiple
            lookupTypeId={StaticLookupsIds.CampaignTypes}
            selectedValues={values.propertyCampaignId}
            filter={{
              pageSize: 50,
              pageIndex: 0,
              propertyId: null,
              eventTypeId: null,
              countryId: null,
              cityId: null,
              propertyCampaignName: "",
            }}
            mapper={(data) => {
              return data.map((item) => ({
                name: item.name,
                campaignName: item.campaignName ?? "",
                propertyCampaignId: item.propertyCampaignId,
              }));
            }}
            queryKey="propertyCampaignName"
            displayLabel={(option) => option?.name ?? ""}
            renderOption={(option) => option?.name}
            chipsLabel={(option) => {
              return option?.name || option.campaignName;
            }}
            getOptionSelected={(option, value) =>
              option?.propertyCampaignId === value?.propertyCampaignId
            }
            onFetchData={GetAllCampaigns}
            onChange={(_e, value) =>
              setFieldValue("propertyCampaignIds", value)
            }
            rootCustomClasses={styles.inputwrapper}
            refetchOnSearch
          />
        </Box>
      </Box>
    ),
    methodOfContact: () => (
      <Box
        display="flex"
        justifyContent="space-between"
        className={styles.optionalFieldContent}
      >
        <label className={styles.label}>
          {translate("method-of-contacts-label")}
        </label>
        <Box flexBasis="60%">
          <CustomAsyncAutocomplete
            autocompleteClasses={styles.optionalField}
            selectedValues={values.rotationSchemaMethodOfContacts}
            multiple
            displayLabel={(option) => option?.lookupItemName ?? ""}
            renderOption={(option) => option?.lookupItemName}
            chipsLabel={(option) => option?.lookupItemName}
            getOptionSelected={(option, value) =>
              option?.lookupItemId === value?.lookupItemId
            }
            onFetchData={lookupItemsGetId}
            filter={{
              lookupTypeId: StaticLookupsIds.MethodOfContact,
              pageIndex: 1,
              pageSize: 10000,
            }}
            mapper={(data) => data}
            onChange={(_e, value) =>
              setFieldValue("rotationSchemaMethodOfContacts", value)
            }
            withoutSearchButton
            rootCustomClasses={styles.inputwrapper}
          />
        </Box>
      </Box>
    ),
    preferredLanguage: () => (
      <Box
        display="flex"
        justifyContent="space-between"
        className={styles.optionalFieldContent}
      >
        <label className={styles.label}>
          {translate("lead-preferred-language-label")}
        </label>
        <Box flexBasis="60%">
          <CustomAsyncAutocomplete
            autocompleteClasses={styles.optionalField}
            multiple
            selectedValues={values.rotationPreferredLanguages}
            displayLabel={(option) => option?.lookupItemName ?? ""}
            renderOption={(option) => option?.lookupItemName}
            chipsLabel={(option) => option?.lookupItemName}
            getOptionSelected={(option, value) =>
              option?.languageId === value?.languageId
            }
            onFetchData={lookupItemsGetId}
            filter={{
              lookupTypeId: StaticLookupsIds.Languages,
              pageIndex: 1,
              pageSize: 10000,
            }}
            mapper={(data) =>
              data.map(({ lookupItemId, lookupItemName }) => ({
                languageId: lookupItemId,
                lookupItemName,
              }))
            }
            onChange={(_e, value) =>
              setFieldValue("rotationPreferredLanguages", value)
            }
            rootCustomClasses={styles.inputwrapper}
            withoutSearchButton
          />
        </Box>
      </Box>
    ),
    location: () => (
      <Box
        display="flex"
        justifyContent="space-between"
        className={styles.optionalFieldContent}
      >
        <label className={styles.label}>
          {translate("specific-location-label")}
        </label>
        <Box flexBasis="60%">
          <CustomAsyncAutocomplete
            autocompleteClasses={styles.optionalField}
            placeholder={translate("location-country")}
            multiple
            selectedValues={values.rotationSchemeCountries}
            onFetchData={lookupItemsGetId}
            displayLabel={(option) => option?.countryName ?? ""}
            renderOption={(option) => option?.countryName}
            chipsLabel={(option) => option?.countryName}
            getOptionSelected={(option, value) =>
              option?.countryId === value?.countryId
            }
            filter={{
              lookupTypeId: StaticLookupsIds.Country,
              pageIndex: 1,
              pageSize: 10000,
            }}
            mapper={(data) =>
              data.map(({ lookupItemId, lookupItemName }) => ({
                countryName: lookupItemName,
                countryId: lookupItemId,
              }))
            }
            onChange={(_e, value) =>
              setFieldValue("rotationSchemeCountries", value)
            }
            rootCustomClasses={styles.inputwrapper}
            withoutSearchButton
          />
          <CustomAsyncAutocomplete
            autocompleteClasses={styles.optionalField}
            placeholder={translate("location-city")}
            multiple
            selectedValues={values.rotationSchemeCities}
            onFetchData={lookupItemsGetId}
            displayLabel={(option) => option?.cityName ?? ""}
            renderOption={(option) => option?.cityName}
            chipsLabel={(option) => option?.cityName}
            getOptionSelected={(option, value) =>
              option?.cityId === value?.cityId
            }
            filter={{
              lookupTypeId: StaticLookupsIds.Cities,
              pageIndex: 1,
              pageSize: 10000,
            }}
            onChange={(_e, value) =>
              setFieldValue("rotationSchemeCities", value)
            }
            mapper={(data) =>
              data.map(({ lookupItemId, lookupItemName }) => ({
                cityName: lookupItemName,
                cityId: lookupItemId,
              }))
            }
            rootCustomClasses={styles.inputwrapper}
            withoutSearchButton
          />
          <CustomAsyncAutocomplete
            autocompleteClasses={styles.optionalField}
            placeholder={translate("location-distric")}
            multiple
            selectedValues={values.rotationSchemeDistricts}
            onFetchData={lookupItemsGetId}
            displayLabel={(option) => option?.districtName ?? ""}
            renderOption={(option) => option?.districtName}
            chipsLabel={(option) => option?.districtName}
            getOptionSelected={(option, value) =>
              option?.districtId === value?.districtId
            }
            filter={{
              lookupTypeId: StaticLookupsIds.District,
              pageIndex: 1,
              pageSize: 10000,
            }}
            mapper={(data) =>
              data.map(({ lookupItemId, lookupItemName }) => ({
                districtId: lookupItemId,
                districtName: lookupItemName,
              }))
            }
            rootCustomClasses={styles.inputwrapper}
            onChange={(_e, value) =>
              setFieldValue("rotationSchemeDistricts", value)
            }
            withoutSearchButton
          />
          <CustomAsyncAutocomplete
            autocompleteClasses={styles.optionalField}
            placeholder={translate("location-community")}
            multiple
            onFetchData={lookupItemsGetId}
            selectedValues={values.rotationSchemeCommunities}
            displayLabel={(option) => option?.communityName ?? ""}
            renderOption={(option) => option?.communityName}
            chipsLabel={(option) => option?.communityName}
            getOptionSelected={(option, value) =>
              option?.communityId === value?.communityId
            }
            filter={{
              lookupTypeId: StaticLookupsIds.Community,
              pageIndex: 1,
              pageSize: 10000,
            }}
            mapper={(data) =>
              data.map(({ lookupItemId, lookupItemName }) => ({
                communityId: lookupItemId,
                communityName: lookupItemName,
              }))
            }
            rootCustomClasses={styles.inputwrapper}
            onChange={(_e, value) =>
              setFieldValue("rotationSchemeCommunities", value)
            }
            withoutSearchButton
          />
          <CustomAsyncAutocomplete
            autocompleteClasses={styles.optionalField}
            placeholder={translate("location-sub-community")}
            multiple
            selectedValues={values.rotationSchemeSubCommunities}
            onFetchData={lookupItemsGetId}
            displayLabel={(option) => option?.subCommunityName ?? ""}
            renderOption={(option) => option?.subCommunityName}
            chipsLabel={(option) => option?.subCommunityName}
            getOptionSelected={(option, value) =>
              option?.subCommunityId === value?.subCommunityId
            }
            filter={{
              lookupTypeId: StaticLookupsIds.SubCommunity,
              pageIndex: 1,
              pageSize: 10000,
            }}
            mapper={(data) =>
              data.map(({ lookupItemId, lookupItemName }) => ({
                subCommunityId: lookupItemId,
                subCommunityName: lookupItemName,
              }))
            }
            rootCustomClasses={styles.inputwrapper}
            onChange={(_e, value) =>
              setFieldValue("rotationSchemeSubCommunities", value)
            }
            withoutSearchButton
          />
          <CustomAsyncAutocomplete
            rootCustomClasses={styles.inputwrapper}
            autocompleteClasses={styles.optionalField}
            selectedValues={values.rotationSchemeProperties}
            multiple
            placeholder={translate("properties-placeholder")}
            mapper={(data) => {
              return data.map((item) => ({
                propertyId: item.propertyId,
                propertyName: item.property && item.property.property_name,
                property_plan:
                  item.property &&
                  item.property.property_plan &&
                  item.property.property_plan.lookupItemName,
              }));
            }}
            queryKey={"search"}
            onFetchData={getProperties}
            filter={{ pageIndex: 0, pageSize: 50 }}
            displayLabel={(option) => option?.propertyName ?? ""}
            renderOption={(option) => option?.propertyName}
            chipsLabel={(option) => {
              return option?.propertyName;
            }}
            getOptionSelected={(option, value) =>
              option?.propertyId === value?.propertyId
            }
            onChange={(_e, value) =>
              setFieldValue("rotationSchemeProperties", value)
            }
            refetchOnSearch
          />
        </Box>
      </Box>
    ),
    bathrooms: () => (
      <Box className={styles.optionalField}>
        <FBFieldWrapper
          labelPosition="side"
          label={translate("bathroom-label")}
        >
          <CustomRangeSlider
            value={values.bathrooms}
            handleChange={(e, newValue) => {
              if (newValue?.[0] || newValue?.[1])
                if (newValue?.[0] > newValue?.[1]) return;
              setFieldValue("bathrooms", [newValue?.[0], newValue?.[1]]);
            }}
            min={0}
            max={8}
            valueLabelDisplay="off"
          />
        </FBFieldWrapper>
      </Box>
    ),
  };
}

export default OptionalFieldDetails;
